import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "normalize.css";
import Settings from "./component/givBee/settings/Settings.js";
import ForgotPassword from "./component/givBee/forgotPassword/ForgotPassword.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ResetPassword from "./component/givBee/forgotPassword/resetPassword/ResetPassword.js";
import ResetPasswordViaEmail from "./component/givBee/forgotPassword/resetPassword/ResetPasswordViaEmail.js";
import Registration from "./component/givBee/registration/Registration.js";
import ConfirmationEmail from "./component/givBee/registration/confirmationEmail/ConfirmationEmail.js";
import Signin from "./component/givBee/signin/Signin.js";
import VerifyAccount from "./component/givBee/verifyAccount/VerifyAccount.js.js";
import VerifyOtpViaEmail from "./component/givBee/verifyAccount/VerifyOtpViaEmail.js.js";
import Blog from "./component/website/blog/Blog.js";
import ContactUs from "./component/website/contactUs/ContactUs.js";
import EventText from "./component/website/eventText/EventText.js";
import Faq from "./component/website/faq/Faq.js";
import Home from "./component/website/home/Home.js";
import NonProfits from "./component/website/nonProfits/NonProfits.js";
import RestaurantsFoodTrucks from "./component/website/restaurantsFoodTrucks/RestaurantsFoodTrucks.js";
import ApplicationLayout from "./layouts/ApplicationLayout.js";
import HomeLayout from "./layouts/HomeLayout.js";
import store from "./redux/store.js";

import AllActiveContactList from "./component/givBee/allActives/AllActiveContactList.js";
import ChangePassword from "./component/givBee/changePassword/ChangePassword.js";
import Group from "./component/givBee/group/Group.js";
import GroupList from "./component/givBee/group/GroupList.js";
import NewContact from "./component/givBee/group/NewContact.js";
import CreateSimilarMessage from "./component/givBee/message/CreateSimilarMessage.js";
import Message from "./component/givBee/message/Message.js";
import MessageList from "./component/givBee/message/MessageList.js";
import PreviewAndSend from "./component/givBee/message/PreviewAndSend.js";
import PrivacyPolicy from "./component/givBee/privacyPolicy/PrivacyPolicy.js";
import Profile from "./component/givBee/profile/Profile.js";
import QuickText from "./component/givBee/quickText/QuickText.js";
import RecipientsList from "./component/givBee/sendHistory/RecipientsList.js";
import SendHistory from "./component/givBee/sendHistory/SendHistory.js";
import TermsConditions from "./component/givBee/termsConditions/TermsConditions.js";
import WidgetPreview from "./component/givBee/widgetTemplate/WidgetPreview.js";
import WidgetTemplate from "./component/givBee/widgetTemplate/WidgetTemplate.js";
import ActivityContactList from "./component/givBee/activityContacts/ActivityContactList.js";
import ScheduledSendList from "./component/givBee/scheduledSend/ScheduledSendList.js";
import ScheduledSend from "./component/givBee/scheduledSend/ScheduledSend.js";
import ShortLinkList from "./component/givBee/shortLink/ShortLinkList.js";
import Pledge from "./component/givBee/pledge/Pledge.js";
import Dashboard from "./component/givBee/dashboard/Dashboard .js";
import LaunchTickerOverlay from "./component/givBee/pledge/LaunchTickerOverlay.js";
import AdminLogin from "./component/adminPanel/adminLogin/AdminLogin.js";
import AdminApplicationLayout from "./layouts/AdminApplicationLayout.js";
import AdminForgotPassword from "./component/adminPanel/adminForgotPassword/AdminForgotPassword.js";
import AdminResetPassword from "./component/adminPanel/adminForgotPassword/adminResetPassword/AdminResetPassword.js";
import AdminAppUserList from "./component/adminPanel/adminAppUser/AdminAppUserList.js";
import AdminDashboard from "./component/adminPanel/adminDashboard/AdminDashboard.js";
import AdminAppUser from "./component/adminPanel/adminAppUser/AdminAppUser.js";
import ProfileManagementList from "./component/adminPanel/profileManagement/ProfileManagementList.js";
import ProfileManagement from "./component/adminPanel/profileManagement/ProfileManagement.js";
import AdminResetPasswordViaEmail from "./component/adminPanel/adminForgotPassword/adminResetPassword/AdminResetPasswordViaEmail.js";
import AdminRegistrationList from "./component/adminPanel/adminRegistration/AdminRegistrationList.js";
import AdminRegistration from "./component/adminPanel/adminRegistration/AdminRegistration.js";
import EmailTemplateList from "./component/adminPanel/emailTemplate/EmailTemplateList.js";
import EmailTemplate from "./component/adminPanel/emailTemplate/EmailTemplate.js";
import VerifyOTP from "./component/givBee/signin/VerifyOTP.js";
import AdminVerifyOTP from "./component/adminPanel/adminLogin/AdminVerifyOTP.js";
import MessageTemplateList from "./component/adminPanel/messageTemplate/MessageTemplateList.js";
import MessageTemplate from "./component/adminPanel/messageTemplate/MessageTemplate.js";
import AdminProfile from "./component/adminPanel/adminProfile/AdminProfile.js";
import EventList from "./component/givBee/eventText/EventList.js";
import Event from "./component/givBee/eventText/Event.js";
import ApplicationEventLayout from "./layouts/ApplicationEventLayout.js";
import DPTextRegistration from "./component/givBee/registration/DPTextRegistration.js";
import DPTextSignin from "./component/givBee/signin/DPTextSignin.js";
import DPTextForgotPassword from "./component/givBee/forgotPassword/DPTextForgotPassword.js";
import DPTextResetPassword from "./component/givBee/forgotPassword/resetPassword/DPTextResetPassword.js";
import DPTextResetPasswordViaEmail from "./component/givBee/forgotPassword/resetPassword/DPTextResetPasswordViaEmail.js";
import DpTextVerifyOTP from "./component/givBee/signin/DpTextVerifyOTP.js";
import DPTextApplicationLayout from "./layouts/DPTextApplicationLayout.js";
import BusinessTypeList from "./component/adminPanel/planTemplate/BusinessTypeList.js";
import BusinessType from "./component/adminPanel/planTemplate/BusinessType.js";
import UseCaseList from "./component/adminPanel/planTemplate/UseCaseList.js";
import UseCase from "./component/adminPanel/planTemplate/UseCase.js";
import PlanList from "./component/adminPanel/planTemplate/PlanList.js";
import PlanAccountList from "./component/adminPanel/planTemplate/PlanAccountList.js";
import ContactFromOtherGroup from "./component/givBee/group/ContactFromOtherGroup.js";
import PrivacyPolicyTemplateList from "./component/adminPanel/privacyPolicyTemplate/PrivacyPolicyTemplateList.js";
import PrivacyPolicyTemplate from "./component/adminPanel/privacyPolicyTemplate/PrivacyPolicyTemplate.js";
import TermsConditionTemplateList from "./component/adminPanel/terms&ConditionTemplate/TermsConditionTemplateList.js";
import TermsConditionTemplate from "./component/adminPanel/terms&ConditionTemplate/TermsConditionTemplate.js";
import PaypalPaymentSuccess from "./component/givBee/billing/PaypalPaymentSuccess.js";
import PaypalPaymentCancel from "./component/givBee/billing/PaypalPaymentCancel.js";
import PurchaseEventPlan from "./component/givBee/eventText/PurchaseEventPlan.js";
import EventBilling from "./component/givBee/billing/EventBilling.js";
import AdminAccountBilling from "./component/adminPanel/adminRegistration/AdminAccountBilling.js";
import MmsImage from "./component/givBee/message/MmsImage.js";
import PaypalDonation from "./component/givBee/paymentGateway/PaypalDonation.js";
import BlackbaudDonation from "./component/givBee/paymentGateway/BlackbaudDonation.js";
import AccountTollfreeNumber from "./component/adminPanel/adminRegistration/AccountTollfreeNumber.js";
import AccountSendHistory from "./component/adminPanel/adminRegistration/AccountSendHistory.js";
import AccountRecipients from "./component/adminPanel/adminRegistration/AccountRecipients.js";
import AccountEventList from "./component/adminPanel/adminRegistration/AccountEventList.js";
import NewRegistration from "./component/givBee/registration/NewRegistration.js";
import AccessDpTextAccount from "./component/givBee/accessDpTextAccount/AccessDpTextAccount.js";
import LaunchSkinnyThermometer from "./component/givBee/pledge/LaunchSkinnyThermometer.js";
import LaunchHorizontalThermometer from "./component/givBee/pledge/LaunchHorizontalThermometer.js";
import LaunchWideThermometer from "./component/givBee/pledge/LaunchWideThermometer.js";
import LaunchSpeedometer from "./component/givBee/pledge/LaunchSpeedometer.js";
import AccountAssignPlan from "./component/adminPanel/adminRegistration/AccountAssignPlan.js";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="App">
        <Provider store={store}>
          <ToastContainer
            style={{
              alignItems: "center",
              fontSize: "small",
              width: "auto",
              maxHeight: "1em",
            }}
            position="top-right"
            autoClose={4000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomeLayout />}>
                <Route path="" element={<Home />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/faqs" element={<Faq />} />
                <Route path="/nonprofits" element={<NonProfits />} />
                <Route path="/eventtext" element={<EventText />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                  path="/restaurant-and-food-truck-texting"
                  element={<RestaurantsFoodTrucks />}
                />
                <Route path="/signup" element={<Registration />} />
                <Route path="/newSignup" element={<NewRegistration />} />
                <Route path="/verifyAccount" element={<VerifyAccount />} />
                <Route
                  path="/confirmationEmail"
                  element={<ConfirmationEmail />}
                />
                <Route path="/signin" element={<Signin />} />
                <Route path="/verifyotp" element={<VerifyOTP />} />
                <Route
                  path="/verifyOtpViaEmail"
                  element={<VerifyOtpViaEmail />}
                />

                {/* <Route
                  path="forgotPasswordEmail"
                  element={<ForgotPasswordEmail />}
                /> */}
                <Route path="forgotPassword" element={<ForgotPassword />} />
                <Route path="resetPassword" element={<ResetPassword />} />
                <Route
                  path="resetPasswordViaEmail"
                  element={<ResetPasswordViaEmail />}
                />
                <Route path="/widgetPreview" element={<WidgetPreview />} />
                <Route
                  path="/launchSpeedometer"
                  element={<LaunchSpeedometer />}
                />
                <Route
                  path="/launchSkinnyThermometer"
                  element={<LaunchSkinnyThermometer />}
                />
                <Route
                  path="/launchWideThermometer"
                  element={<LaunchWideThermometer />}
                />
                <Route
                  path="/launchHorizontalThermometer"
                  element={<LaunchHorizontalThermometer />}
                />
                <Route
                  path="/tickerOverlay"
                  element={<LaunchTickerOverlay />}
                />
                <Route path="/ppDonation" element={<PaypalDonation />} />
                <Route path="/bbDonation" element={<BlackbaudDonation />} />

                <Route path="/dptextSignup" element={<DPTextRegistration />} />
                <Route path="/dptextSignin" element={<DPTextSignin />} />
                <Route path="/dpVerifyotp" element={<DpTextVerifyOTP />} />
                <Route
                  path="/dpForgotPassword"
                  element={<DPTextForgotPassword />}
                />
                <Route
                  path="/dpResetPassword"
                  element={<DPTextResetPassword />}
                />
                <Route
                  path="/dptextReset"
                  element={<DPTextResetPasswordViaEmail />}
                />

                <Route path="/ApLogin" element={<AdminLogin />} />
                <Route path="/ApVerifyotp" element={<AdminVerifyOTP />} />
                <Route
                  path="/ApForgotPassword"
                  element={<AdminForgotPassword />}
                />
                <Route
                  path="/ApResetPassword"
                  element={<AdminResetPassword />}
                />
                <Route
                  path="/ApResetPasswordViaEmail"
                  element={<AdminResetPasswordViaEmail />}
                />
                <Route
                  path="/paypalPaymentSuccess"
                  element={<PaypalPaymentSuccess />}
                />
                <Route
                  path="/paypalPaymentCancel"
                  element={<PaypalPaymentCancel />}
                />
              </Route>
              <Route path="/" element={<ApplicationLayout />}>
                <Route path="/analytics" element={<Dashboard />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/messages" element={<MessageList />} />
                <Route path="/message" element={<Message />} />
                <Route path="/mmsImage" element={<MmsImage />} />
                <Route
                  path="/createSimilarMessage"
                  element={<CreateSimilarMessage />}
                />
                <Route path="/previewAndSend" element={<PreviewAndSend />} />
                <Route path="/widgetTemplate" element={<WidgetTemplate />} />
                <Route path="/qwiktext" element={<QuickText />} />
                <Route path="/groups" element={<GroupList />} />
                <Route path="/group" element={<Group />} />
                <Route
                  path="/contactsFromOtherGroup"
                  element={<ContactFromOtherGroup />}
                />
                <Route path="/contact" element={<NewContact />} />
                <Route path="/contacts" element={<AllActiveContactList />} />

                {/* <Route path="/profile" element={<Profile />} /> */}
                <Route path="/sendHistory" element={<SendHistory />} />
                <Route path="/recipientsList" element={<RecipientsList />} />
                {/* <Route path="/changePassword" element={<ChangePassword />} /> */}
                <Route
                  path="/activityContactList"
                  element={<ActivityContactList />}
                />
                <Route path="/scheduledSends" element={<ScheduledSendList />} />
                <Route path="/scheduleSend" element={<ScheduledSend />} />
                <Route path="/shortLinkList" element={<ShortLinkList />} />
                <Route path="/pledge" element={<Pledge />} />
                <Route path="/eventMgmt" element={<EventList />} />
                <Route path="/event" element={<Event />} />
                <Route
                  path="/purchaseEventPlan"
                  element={<PurchaseEventPlan />}
                />
              </Route>
              <Route path="/" element={<ApplicationLayout pageId="profile" />}>
                <Route path="/profile" element={<Profile />} />
                <Route path="/changePassword" element={<ChangePassword />} />
              </Route>
              <Route path="/" element={<ApplicationEventLayout />}>
                <Route path="/editEvent" element={<Event />} />
                <Route path="/eventMessages" element={<MessageList />} />
                <Route path="/eventMessage" element={<Message />} />
                <Route path="/eventShortLinkList" element={<ShortLinkList />} />
                <Route
                  path="/eventCreateSimilarMessage"
                  element={<CreateSimilarMessage />}
                />
                <Route
                  path="/eventPreviewAndSend"
                  element={<PreviewAndSend />}
                />
                <Route
                  path="/eventWidgetTemplate"
                  element={<WidgetTemplate />}
                />
                <Route path="/eventQwikText" element={<QuickText />} />
                <Route path="/eventGroups" element={<GroupList />} />
                <Route path="/eventGroup" element={<Group />} />
                <Route
                  path="/eventContactsFromOtherGroup"
                  element={<ContactFromOtherGroup />}
                />
                <Route path="/eventContact" element={<NewContact />} />
                <Route
                  path="/eventContacts"
                  element={<AllActiveContactList />}
                />
                <Route
                  path="/eventActivityContactList"
                  element={<ActivityContactList />}
                />
                <Route
                  path="/eventScheduledSends"
                  element={<ScheduledSendList />}
                />
                <Route path="/eventScheduleSend" element={<ScheduledSend />} />
                <Route path="/eventSendHistory" element={<SendHistory />} />
                <Route
                  path="/eventRecipientsList"
                  element={<RecipientsList />}
                />
                <Route path="/eventInsights" element={<Dashboard />} />
                <Route path="/eventBillingInfo" element={<EventBilling />} />
                <Route path="/purchsePlan" element={<PurchaseEventPlan />} />
                <Route path="/eventPledge" element={<Pledge />} />
              </Route>
              <Route path="/accessDpTextAccount" element={< AccessDpTextAccount />} />
              <Route path="/" element={<DPTextApplicationLayout />}>
                <Route path="/dptextMessages" element={<MessageList />} />
                <Route path="/dptextMessage" element={<Message />} />
                <Route path="/dptextPledge" element={<Pledge />} />
                <Route
                  path="/dptextShortLinkList"
                  element={<ShortLinkList />}
                />
                <Route
                  path="/dptextCreateSimilarMessage"
                  element={<CreateSimilarMessage />}
                />
                <Route
                  path="/dptextPreviewAndSend"
                  element={<PreviewAndSend />}
                />
                <Route
                  path="/dptextWidgetTemplate"
                  element={<WidgetTemplate />}
                />
                <Route path="/dptextQwikText" element={<QuickText />} />
                <Route path="/dptextGroups" element={<GroupList />} />
                <Route path="/dptextGroup" element={<Group />} />
                <Route
                  path="/dptextContactsFromOtherGroup"
                  element={<ContactFromOtherGroup />}
                />
                <Route path="/dptextContact" element={<NewContact />} />
                <Route
                  path="/dptextContacts"
                  element={<AllActiveContactList />}
                />
                <Route
                  path="/dptextActivityContactList"
                  element={<ActivityContactList />}
                />
                <Route
                  path="/dptextScheduledSends"
                  element={<ScheduledSendList />}
                />
                <Route path="/dptextScheduleSend" element={<ScheduledSend />} />
                <Route path="/dptextSendHistory" element={<SendHistory />} />
                <Route
                  path="/dptextRecipientsList"
                  element={<RecipientsList />}
                />
                <Route path="/dptextAnalytics" element={<Dashboard />} />
                <Route path="/dptextsettings" element={<Settings />} />
              </Route>

              <Route path="/" element={<AdminApplicationLayout />}>
                <Route path="/APDashboard" element={<AdminDashboard />} />
                <Route path="/appUserList" element={<AdminAppUserList />} />
                <Route path="/appUser" element={<AdminAppUser />} />
                <Route path="/apSettings" element={<ProfileManagementList />} />
                <Route path="/apProfileMgmnt" element={<ProfileManagement />} />
                <Route
                  path="/accountList"
                  element={<AdminRegistrationList />}
                />
                <Route path="/viewAccount" element={<AdminRegistration />} />
                <Route
                  path="/accountBilling"
                  element={<AdminAccountBilling />}
                />
                <Route
                  path="/accountEventList"
                  element={<AccountEventList />}
                />
                <Route
                  path="/accountSendHistory"
                  element={<AccountSendHistory />}
                />
                <Route
                  path="/accountRecipients"
                  element={<AccountRecipients />}
                />
                <Route
                  path="/accountTollfreeNumber"
                  element={<AccountTollfreeNumber />}
                />
                <Route
                  path="/accountAssignPlan"
                  element={<AccountAssignPlan />}
                />
                <Route
                  path="/emailTemplateList"
                  element={<EmailTemplateList />}
                />
                <Route
                  path="/smsTemplateList"
                  element={<MessageTemplateList />}
                />
                <Route path="/smsTemplate" element={<MessageTemplate />} />
                <Route path="/emailTemplate" element={<EmailTemplate />} />
                <Route path="/ApProfile" element={<AdminProfile />} />
                <Route path="/billingPlans" element={<BusinessTypeList />} />
                <Route path="/businessType" element={<BusinessType />} />
                <Route path="/useCaseList" element={<UseCaseList />} />
                <Route path="/useCase" element={<UseCase />} />
                <Route path="/planList" element={<PlanList />} />
                <Route path="/planAccountList" element={<PlanAccountList />} />
                <Route
                  path="/aptermsConditionsList"
                  element={<TermsConditionTemplateList />}
                />
                <Route
                  path="/termsConditions"
                  element={<TermsConditionTemplate />}
                />
                <Route
                  path="/privacyPolicyList"
                  element={<PrivacyPolicyTemplateList />}
                />
                <Route
                  path="/privacyPolicy"
                  element={<PrivacyPolicyTemplate />}
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </Provider>
      </div>
    );
  }
}
export default App;
